import React from "react";
import { FaRegSquare, FaSquareCheck } from "react-icons/fa6";

export interface CheckboxOption {
  value: string;
  label?: string;
}

export interface CheckboxGroupProps {
  options: CheckboxOption[];
  selectedValues: string[]; // Array of selected values
  onChange: (values: string[]) => void; // Callback when the selected values change
  className?: string; // Optional custom class for the container
  buttonClassName?: string; // Optional custom class for each button
  checkboxIconClassName?: string; // Optional custom class for the checkbox icons
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  options,
  selectedValues,
  onChange,
  className = "",
  buttonClassName = "",
  checkboxIconClassName = "",
}) => {
  const isSelected = (value: string) => selectedValues.includes(value);

  const handleCheckboxClick = (value: string) => {
    if (isSelected(value)) {
      onChange(selectedValues.filter((v) => v !== value));
    } else {
      onChange([...selectedValues, value]);
    }
  };

  return (
    <div className={`grid grid-cols-1 gap-4 ${className}`}>
      {options.map((item, index) => (
        <div key={index} className="flex items-start justify-start">
          <button
            onClick={() => handleCheckboxClick(item.value)}
            className={`w-full items-center justify-center bg-white/15 backdrop-blur-md flex flex-row py-4 gap-6 ${buttonClassName}`}
          >
            {!isSelected(item.value) ? (
              <FaRegSquare
                className={`text-white h-[1.5rem] ${checkboxIconClassName}`}
              />
            ) : (
              <FaSquareCheck
                className={`text-white h-[1.5rem] ${checkboxIconClassName}`}
              />
            )}

            <span className="text-[12px] md:text-[20px] text-white font-[600] flex-grow text-left">
              {item.label || item.value}
            </span>
          </button>
        </div>
      ))}
    </div>
  );
};

export default CheckboxGroup;
